import styles from "./index.module.css";

const Logo = () => {
  return <span className={styles.logo}>Wheel of Fortune</span>;
};

export default Logo;
